
const listeAffichageDynamique = (path) => {
  if (!path) return '#82E19A';

  if (path.includes('/accueilentreprise')) {
    return 'linear-gradient(to right, rgba(184,183,183,1), rgba(234,230,230,1), rgba(242,242,242,1))';
  }

  if (path.includes('/homepagepro')) {
    return 'linear-gradient(90deg, #CBA052 0%, #ECDDAE 50%, #EABE5E 100%)';
  }

  if (path.includes('/accueil')) {
    return '#74d68c';
  }

  return '#82E19A';
};

export default listeAffichageDynamique;
